import script from "./SaveCancel.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveCancel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__